import { config as AWSConfig, S3 } from "aws-sdk";
import { getAWSBucketName } from "../helper-methods";
// import ThumbnailGenerator from 'video-thumbnail-generator';
class S3BucketUploader {
  /**
   * Static properties
   */
  static config = null;

  static setConfigs(config) {
    S3BucketUploader.config = config;
  }

  static getCreds = (url, authToken = null) => {
    return new Promise(async (resolve, reject) => {
      console.log(`Add this to lovable for the page ${window.location.pathname} : GET ${new URL(url, window.location.origin).pathname}`)
      let headers = {};
      if (authToken) {
        headers["Authorization"] = "Bearer " + authToken;
      }
      fetch(url, {
        method: "GET",
        headers
      })
        .then(res => {
          return res.json();
        })
        .then(res => {
          resolve(S3BucketUploader.prepareAWSConfigs(res));
        });
    });
  };

  static prepareAWSConfigs = config => {
    return {
      accessKeyId: config.AccessKeyId,
      secretAccessKey: config.SecretAccessKey,
      sessionToken: config.SessionToken,
      S3BucketName: config.S3BucketName,
      S3Region: config.S3Region
    };
  };

  /**
   * Non static properties
   */

  constructor(config) {
    S3BucketUploader.setConfigs(config);
  }

  uploadFile = (
    file,
    onComplete = null,
    onProgressCallBack = () => {},
    fileType = "image",
    bucketName
  ) => {
    console.log("uploading file ....",
    bucketName
    )
    return new Promise((resolve, reject) => {
      const { config } = S3BucketUploader;
      AWSConfig.update(config);
      // Configure your region
      AWSConfig.region = config.S3Region;
      var bucket = new S3({
        params: {
          Bucket:bucketName?bucketName: getAWSBucketName(fileType)
        }
      });
      const Key = String(+new Date());
      var params = { Key, ContentType: file.type, Body: file };
      bucket
        .upload(params)
        .on("httpUploadProgress", onProgressCallBack)
        .send((err, success) => {
          if (err) {
            console.log("err",err)
            reject(err);
          } else {
            console.log("success",success)
            resolve(success);
          }
        });
    });
  };
}

export default S3BucketUploader;
